export function applySelectionToPattern(selection: string, pattern: string): string {
    let patSplit = pattern.split('');
    var selIdx = 0;
    for (var patIdx = 0; patIdx < patSplit.length; patIdx++) {
        if (selIdx == selection.length) break;

        if (patSplit[patIdx] == " " || ['a', 'e', 'i', 'o', 'u'].indexOf(patSplit[patIdx]) < 0) {
            patSplit[patIdx] = selection[selIdx];
            selIdx++;
        }
    }
    return patSplit.join('');
}

export function patternSlotCount(pattern: string) {
    return pattern.replace(/[^aeiou]/g, ' ').split("").filter(l => l == ' ').length
}

function availableHintIndexes(pattern: string) {
    return pattern.split('').map((char,idx) => idx).filter(idx =>  pattern[idx] == " ")
}

export function addHintToPattern(pattern: string, word: string, notword: string = null) {
    let validHintIdxs = availableHintIndexes(pattern)

    if (notword) {
        //did they ignore the clue?
        for (var i=0; i < pattern.length; i++) {
            if (pattern[i] != ' ' && pattern[i] != notword[i]) {
                //they must have ignored a clue, don't give them another.
                return pattern;
            }
        }
        validHintIdxs = validHintIdxs.filter(idx => word[idx] != notword[idx]);
    }
    
    if (validHintIdxs.length > 0) {
       let newPat = pattern.split('');
       let hintIndex = validHintIdxs[0];
       newPat[hintIndex] = word[hintIndex]
       return newPat.join('');
    } else {
        return pattern;
    }
}